export default __webpack_public_path__ + "static/media/holding.c9129c23.png";